module.exports = __webpack_public_path__ + "cfp/Morales_Building Security That Thinks.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/Morales_Building Security That Thinks.pdf
// module id = 926
// module chunks = 0